<template>
  <div>
    <form ref="uploadForm">
      <div>
    <div class="flex">
      <div class="w-full flex flex-col space-y-6">
        <div
          class="p-5 bg-white rounded-xl border border-brd-primary-color shadow-sm"
        >
          <label
            class="flex items-center text-base font-semibold text-txt-primary-color mb-3"
          >
            📷 1x1 Picture
          </label>

          <div class="flex items-center space-x-3">
            <label
              for="photo"
              class="cursor-pointer inline-block px-4 py-2 rounded-lg bg-upload-primary text-sm font-semibold text-txt-primary-color hover:bg-upload-secondary transition"
            >
              Choose File
            </label>

            <span class="text-sm text-txt-primary-color">
              {{
                formData.photo ? formData.photo.name : "No file chosen"
              }}
            </span>
          </div>

          <input
            id="photo"
            type="file"
            accept="image/*"
            required
            class="hidden"
            @change="handleUpload('photo', $event)"
          />
          <p class="mt-1 text-xs text-txt-primary-color">
            Upload a clear 1x1 photo
          </p>
        </div>

        <div
          class="p-5 bg-white rounded-xl border border-brd-primary-color shadow-sm"
        >
          <label
            class="flex items-center text-base font-semibold text-txt-primary-color mb-3"
          >
            🪪 Valid ID
          </label>

          <div class="flex items-center space-x-3">
            <label
              for="validid"
              class="cursor-pointer inline-block px-4 py-2 rounded-lg bg-upload-primary text-sm font-semibold text-txt-primary-color hover:bg-upload-secondary transition"
            >
              Choose File
            </label>

            <span class="text-sm text-txt-primary-color">
              {{ formData.validid ? formData.validid.name : "No file chosen" }}
            </span>
          </div>

          <input
            id="validid"
            type="file"
            accept="image/*,.pdf"
            required
            class="hidden"
            @change="handleUpload('validid', $event)"
          />
          <p class="mt-1 text-xs text-txt-primary-color">
            Upload a scanned valid ID (image or PDF)
          </p>
        </div>

        <div
          class="p-5 bg-white rounded-xl border border-brd-primary-color shadow-sm"
        >
          <label
            class="flex items-center text-base font-semibold text-txt-primary-color mb-3"
          >
            📄 Agent Resume / CV
          </label>

          <div class="flex items-center space-x-3">
            <label
              for="resume"
              class="cursor-pointer inline-block px-4 py-2 rounded-lg bg-upload-primary text-sm font-semibold text-txt-primary-color hover:bg-upload-secondary transition"
            >
              Choose File
            </label>

            <span class="text-sm text-txt-primary-color">
              {{
                formData.resume
                  ? formData.resume.name
                  : "No file chosen"
              }}
            </span>
          </div>

          <input
            id="resume"
            type="file"
            accept=".pdf,.doc,.docx,image/*"
            required
            class="hidden"
            @change="handleUpload('resume', $event)"
          />
          <p class="mt-1 text-xs text-txt-primary-color">
            Attach your Resume or CV (PDF or Word).
          </p>
        </div>
      </div>
    </div>
  </div>
  </form>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  emits: ["update:formData"],
  setup(props, { emit }) {
    const handleUpload = (field, event) => {
      const file = event.target.files[0];
      emit("update:formData", { field, value: file });
    };

    return { handleUpload };
  },
};
</script>
